import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import WebsitePreview from '../../WebsitePreview';
import WebsitePreviewPromo from '../../WebsitePreview/WebsitePreviewPromo';
import PreviewOverlay from '../../WebsitePreview/PreviewOverlay';

/**
 * RsvpPreview
 *
 * @param {boolean} hasEvents  - whether user has events or no
 * @param {boolean} hasGuests - whether user has guests or no
 * @param {string} pageType - page type
 * @param {function} openEventFormModal - dispatch show modal EVENT_FORM
 */

const RsvpPreview = ({ hasEvents, hasGuests, pageType, openEventFormModal }) => {
  const showWebsitePreviewPromo = !hasEvents && !hasGuests;
  const showWebsitePreviewOverlay = !hasEvents && hasGuests;

  return (
    <div className="website-preview__rsvp">
      {showWebsitePreviewPromo ? <WebsitePreviewPromo pageType={pageType} /> : <WebsitePreview />}
      {showWebsitePreviewOverlay && (
        <PreviewOverlay
          copy="You must create an event to use online RSVP"
          buttonText="Add Event"
          buttonAction={openEventFormModal}
        />
      )}
    </div>
  );
};

RsvpPreview.propTypes = {
  pageType: PropTypes.string,
  hasEvents: PropTypes.bool,
  hasGuests: PropTypes.bool,
  openEventFormModal: PropTypes.func,
};

const mapStateToProps = state => ({
  hasEvents: state.website.entities.orderedIds.length > 0,
  hasGuests: state.guestList.guests.orderedIds.length > 0,
});

export default connect(mapStateToProps)(RsvpPreview);
